// src/redux/reducers/filtersReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {},
  preservedFilters: {} // Store filters for each path
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = action.payload;
    },
    resetFilters(state) {
      state.filters = {};
    },
    setPreservedFilters(state, action) {
      const { path, filters } = action.payload;
      state.preservedFilters[path] = filters;
    },
    removePreservedFilters(state, action) {
      const { path } = action.payload;
      delete state.preservedFilters[path];
    },
    clearNonBreadcrumbFilters(state, action) {
      const { activePaths } = action.payload;
      const newPreservedFilters = {};
      Object.keys(state.preservedFilters).forEach(path => {
        if (activePaths.includes(path)) {
          newPreservedFilters[path] = state.preservedFilters[path];
        }
      });
      state.preservedFilters = newPreservedFilters;
    }
  },
});

export const { 
  setFilters, 
  resetFilters, 
  setPreservedFilters, 
  removePreservedFilters,
  clearNonBreadcrumbFilters 
} = filtersSlice.actions;

export default filtersSlice.reducer;
